/* src/app/webhook-creator/webhook-creator/webhook-edit/webhook-edit-configuration/webhook-edit-configuration.component.scss */
.extra-new {
  position: absolute;
  top: 15px;
  right: 10px;
}
.extra-new-detail {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  align-items: baseline;
}
.extra-input {
  width: 300px;
}
/*# sourceMappingURL=webhook-edit-configuration.component.css.map */
